import Blue from "~/core";

new Blue({
	name: 'New Password Checker',
	selector: ".new-password",
	setup(container) {
    const input = container.querySelector('.new-password__input');
		const explanation = container.querySelector('.new-password__explanation');

		this.$addEvents(input, "input", e => {
			let val = e.target.value;
			this.$verify(container, explanation, val);
		});
	}
});